// extracted by mini-css-extract-plugin
export default {"deleteButton":"text-edit_deleteButton__5rLMS"};